import { useState } from "react";
import { toast } from "sonner";
import { ShieldAlert, FileText, Loader2, ExternalLink } from "lucide-react";
import { getAuthToken } from "../../utils/auth";

const API = process.env.REACT_APP_BACKEND_URL;

const Row = ({ label, value }) => (value ? (
  <div><p className="text-[11px] uppercase tracking-wide text-[#5A6880]">{label}</p><p className="text-sm font-semibold text-[#1B2A4A]">{value}</p></div>
) : null);

export const ClaimHelpCard = ({ lead }) => {
  const c = lead.claim_help;
  const [opening, setOpening] = useState(null);

  const openFile = async (f) => {
    setOpening(f.id);
    try {
      const res = await fetch(`${API}/api/advisor/leads/${lead.id}/claim-files/${f.id}`, { headers: { Authorization: `Bearer ${getAuthToken()}` } });
      if (!res.ok) throw new Error();
      const url = URL.createObjectURL(await res.blob());
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener";
      if (!window.open(url, "_blank")) { a.download = f.name || "document"; a.click(); }
    } catch {
      toast.error("Could not open the document");
    }
    setOpening(null);
  };

  return (
    <div className="mb-6 rounded-2xl border border-rose-200 bg-rose-50/60 p-5" data-testid="lead-claim-help-card">
      <h2 className="mb-4 flex items-center gap-2 font-semibold text-rose-700"><ShieldAlert className="h-5 w-5" /> Claim help request</h2>
      <div className="mb-4 grid grid-cols-2 gap-4 sm:grid-cols-3">
        <Row label="Problem" value={c.issue_type} />
        <Row label="Policy type" value={c.policy_type} />
        <Row label="Insurer" value={c.insurer} />
        <Row label="Bought from" value={c.bought_from} />
        <Row label="Claim amount" value={c.claim_amount && `₹${c.claim_amount}`} />
        <Row label="City" value={c.city} />
      </div>
      <p className="mb-4 whitespace-pre-wrap rounded-xl bg-white p-3 text-sm text-[#2E3B57]" data-testid="lead-claim-help-description">{c.description}</p>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-[#3A4557]">Documents ({c.files?.length || 0})</p>
      {c.files?.length ? (
        <div className="flex flex-wrap gap-2">
          {c.files.map((f) => (
            <button key={f.id} onClick={() => openFile(f)} disabled={opening === f.id} data-testid={`lead-claim-file-${f.id}`}
              className="flex max-w-full items-center gap-2 rounded-lg border border-[#C9D4E6] bg-white px-3 py-2 text-sm transition-colors hover:border-rose-300">
              {opening === f.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4 text-rose-600" />}
              <span className="truncate">{f.name}</span><ExternalLink className="h-3.5 w-3.5 shrink-0 text-[#5A6880]" />
            </button>
          ))}
        </div>
      ) : <p className="text-sm text-[#5A6880]">No documents attached.</p>}
    </div>
  );
};
